export default {
  current: {}
}
